import { useRecoilValue } from 'recoil';

import { findCurrentUserEvent } from '../shared/lib';
import { currentEventIdState } from '../state/event';
import type { User } from '../types';

const useCurrentUserEvent = (user?: User) => {
  const currentEventId = useRecoilValue(currentEventIdState);
  return currentEventId && user ? findCurrentUserEvent(currentEventId)(user.userEvents) : undefined;
};

export default useCurrentUserEvent;
